<template>
    <v-dialog v-model="product_detail.is_open"
              fullscreen
              persistent
              transition="dialog-bottom-transition"
              :retain-focus=false>
        <v-card>
            <v-toolbar dark
                       color="primary">
                <v-btn icon
                       dark
                       @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>商品詳細</v-toolbar-title>
            </v-toolbar>
            <template v-if="product_detail.item">
                <v-container>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">1. 商品コード情報</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>JANコード</th>
                                    <td>{{ product_detail.item.jan_code }}</td>
                                    <th>JANコード識別</th>
                                    <td>{{ product_detail.item.jan_code_class }}</td>
                                    <th>旧JANコード</th>
                                    <td>{{ product_detail.item.jan_code_old }}</td>
                                    <th>統一商品コード</th>
                                    <td>{{ product_detail.item.unified_product_code }}</td>
                                    <th>薬価基準収載医薬品コード</th>
                                    <td>{{ product_detail.item.nhi_drug_code }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">旧・薬価基準収載医薬品コード</th>
                                    <td class="tborder">{{ product_detail.item.nhi_drug_code_old }}</td>
                                    <th class="tborder">HOTコード</th>
                                    <td class="tborder">{{ product_detail.item.hot_code }}</td>
                                    <th class="tborder">レセプトコード1</th>
                                    <td class="tborder">{{ product_detail.item.receipt_code_1 }}</td>
                                    <th class="tborder">レセプトコード2</th>
                                    <td class="tborder">{{ product_detail.item.receipt_code_2 }}</td>
                                    <th class="tborder">YJコード</th>
                                    <td class="tborder">{{ product_detail.item.yj_code }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">2. 分類情報</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>薬効分類コード</th>
                                    <td>{{ product_detail.item.drug_class_code }}</td>
                                    <th>薬効分類名</th>
                                    <td>{{ product_detail.item.drug_class_name }}</td>
                                    <th>使用区分コード</th>
                                    <td>{{ product_detail.item.use_class_code }}</td>
                                    <th>使用区分名称</th>
                                    <td>{{ product_detail.item.use_class_name }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">日本標準商品分類番号</th>
                                    <td class="tborder">{{ product_detail.item.jpn_product_class_no }}</td>
                                    <th class="tborder">剤型コード</th>
                                    <td class="tborder">{{ product_detail.item.dosage_form_code }}</td>
                                    <th class="tborder">剤型記号</th>
                                    <td class="tborder">{{ product_detail.item.dosage_form_sign }}</td>
                                    <th class="tborder">剤型名称</th>
                                    <td class="tborder">{{ product_detail.item.dosage_form_name }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">3. 名称情報</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>商品名</th>
                                    <td>{{ product_detail.item.product_name }}</td>
                                    <th>半角商品名</th>
                                    <td>{{ product_detail.item.product_name_half }}</td>
                                    <th>規格容量</th>
                                    <td>{{ product_detail.item.standard_capacity }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">半角規格容量</th>
                                    <td class="tborder">{{ product_detail.item.standard_capacity_half }}</td>
                                    <th class="tborder">商品名（カナソート用)</th>
                                    <td class="tborder">{{ product_detail.item.product_name_kana }}</td>
                                    <th class="tborder">商品名（漢方用記号)</th>
                                    <td class="tborder">{{ product_detail.item.product_name_kanji }}</td>
                                    <th class="tborder">一般名称</th>
                                    <td class="tborder">{{ product_detail.item.common_name }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">薬価収載名称</th>
                                    <td class="tborder">{{ product_detail.item.nhi_price_list }}</td>
                                    <th class="tborder">レセ用医薬品名</th>
                                    <td class="tborder">{{ product_detail.item.receipt_product_name }}</td>
                                    <th class="tborder">規格・単位名称</th>
                                    <td class="tborder">{{ product_detail.item.standards_unit_name }}</td>
                                    <th class="tborder">規格・単位記号</th>
                                    <td class="tborder">{{ product_detail.item.standards_unit_sign }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">4. 会社情報</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>販売元コード</th>
                                    <td>{{ product_detail.item.seller_code }}</td>
                                    <th>販売元名</th>
                                    <td>{{ product_detail.item.seller_name }}</td>
                                    <th>販売元名カナ</th>
                                    <td>{{ product_detail.item.seller_name_kana }}</td>
                                    <th>販売元名（略名）</th>
                                    <td>{{ product_detail.item.seller_name_s }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">製造元(輸入元)コード</th>
                                    <td class="tborder">{{ product_detail.item.manufacturer_code }}</td>
                                    <th class="tborder">製造元(輸入元)名</th>
                                    <td class="tborder">{{ product_detail.item.manufacturer_name }}</td>
                                    <th class="tborder">製造元(輸入元)名カナ</th>
                                    <td class="tborder">{{ product_detail.item.manufacturer_name_kana }}</td>
                                    <th class="tborder">製造元(輸入元)名（略名）</th>
                                    <td class="tborder">{{ product_detail.item.manufacturer_name_s }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">5. 包装仕様</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>包装形態</th>
                                    <td>{{ product_detail.item.package_form }}</td>
                                    <th>包装単位（数字）</th>
                                    <td>{{ product_detail.item.package_unit_num }}</td>
                                    <th>包装単位（単位）</th>
                                    <td>{{ product_detail.item.package_unit_unit }}</td>
                                    <th>包装数量（数字）</th>
                                    <td>{{ product_detail.item.package_quantity_num }}</td>
                                    <th>包装数量（単位）</th>
                                    <td>{{ product_detail.item.package_quantity_unit }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">包装入数（数字）</th>
                                    <td class="tborder">{{ product_detail.item.package_num_num }}</td>
                                    <th class="tborder">包装入数（単位）</th>
                                    <td class="tborder">{{ product_detail.item.package_num_unit }}</td>
                                    <th class="tborder">包装総量（数字）</th>
                                    <td class="tborder">{{ product_detail.item.package_total_num }}</td>
                                    <th class="tborder">包装総量（単位）</th>
                                    <td class="tborder">{{ product_detail.item.package_total_unit }}</td>
                                    <th class="tborder">包装容量（数字）</th>
                                    <td class="tborder">{{ product_detail.item.package_tcapacity_num }}</td>
                                    <th class="tborder">包装容量（単位）</th>
                                    <td class="tborder">{{ product_detail.item.package_tcapacity_unit }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">6. 薬価</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>包装薬価係数</th>
                                    <td>{{ product_detail.item.package_drug_price }}</td>
                                    <th>現単位薬価</th>
                                    <td>{{ product_detail.item.unit_price_now }}</td>
                                    <th>現包装薬価</th>
                                    <td>{{ product_detail.item.package_price_now }}</td>
                                    <th>旧単位薬価</th>
                                    <td>{{ product_detail.item.unit_price_old }}</td>
                                    <th>旧包装薬価</th>
                                    <td>{{ product_detail.item.package_price_old }}</td>
                                    <th>告示単位薬価</th>
                                    <td>{{ product_detail.item.notice_unit_price }}</td>
                                    <th>告示包装薬価</th>
                                    <td>{{ product_detail.item.notice_package_price }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">7. 日付情報</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>薬価改定年月日</th>
                                    <td>{{ product_detail.item.nhi_price_rev_date }}</td>
                                    <th>薬価収載年月日</th>
                                    <td>{{ product_detail.item.nhi_price_list_date }}</td>
                                    <th>販売開始年月日</th>
                                    <td>{{ product_detail.item.sales_start_date }}</td>
                                    <th>経過措置年月日</th>
                                    <td>{{ product_detail.item.transitional_measures_date }}</td>
                                    <th>発売中止年月日</th>
                                    <td>{{ product_detail.item.sales_stop_date }}</td>
                                    <th>製造中止年月日</th>
                                    <td>{{ product_detail.item.discontinued_date }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">8. 各種区分</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>毒薬</th>
                                    <td>{{ product_detail.item.poison }}</td>
                                    <th>劇薬</th>
                                    <td>{{ product_detail.item.strong_medicine }}</td>
                                    <th>麻薬</th>
                                    <td>{{ product_detail.item.drug }}</td>
                                    <th>向精神薬</th>
                                    <td>{{ product_detail.item.psychotropic_drug }}</td>
                                    <th>覚醒剤</th>
                                    <td>{{ product_detail.item.stimulant_drug }}</td>
                                    <th>覚醒剤原料</th>
                                    <td>{{ product_detail.item.stimulant_drug_material }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">習慣性医薬品</th>
                                    <td class="tborder">{{ product_detail.item.addictive_medicine }}</td>
                                    <th class="tborder">指定医薬品(旧規制区分)</th>
                                    <td class="tborder">{{ product_detail.item.designated_drug_old }}</td>
                                    <th class="tborder">要指示医薬品(旧規制区分)</th>
                                    <td class="tborder">{{ product_detail.item.required_designated_drug_old }}</td>
                                    <th class="tborder">血液製剤</th>
                                    <td class="tborder">{{ product_detail.item.blood_product }}</td>
                                    <th class="tborder">日本薬局方</th>
                                    <td class="tborder">{{ product_detail.item.jpn_pharmacopoeia }}</td>
                                    <th class="tborder">有効期間   [ヶ月]</th>
                                    <td class="tborder">{{ product_detail.item.expiration_date }}</td>
                                    <th class="tborder"></th>
                                    <td class="tborder"></td>
                                </tr>
                                <tr>
                                    <th class="tborder">使用期限   [ヶ月]</th>
                                    <td class="tborder">{{ product_detail.item.use_date }}</td>
                                    <th class="tborder">生物由来製品</th>
                                    <td class="tborder">{{ product_detail.item.biological }}</td>
                                    <th class="tborder">後発品</th>
                                    <td class="tborder">{{ product_detail.item.generic }}</td>
                                    <th class="tborder">薬価基準収載区分</th>
                                    <td class="tborder">{{ product_detail.item.nhi_price_list_cless }}</td>
                                    <th class="tborder">記帳義務区分</th>
                                    <td class="tborder">{{ product_detail.item.bookkeeping_class }}</td>
                                    <th class="tborder">商品区分</th>
                                    <td class="tborder">{{ product_detail.item.product_class }}</td>
                                    <th class="tborder">処方箋医薬品</th>
                                    <td class="tborder">{{ product_detail.item.prescription_drugs }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">中止理由区分</th>
                                    <td class="tborder">{{ product_detail.item.stop_reason_class }}</td>
                                    <th class="tborder">未使用（旧流通管理品）</th>
                                    <td class="tborder">{{ product_detail.item.unused }}</td>
                                    <th class="tborder">メンテナンス区分</th>
                                    <td class="tborder">{{ product_detail.item.maintenance_class }}</td>
                                    <th class="tborder">後発品のある先発品区分</th>
                                    <td class="tborder">{{ product_detail.item.original_generic_class }}</td>
                                    <th class="tborder">オーソライズド・ジェネリック</th>
                                    <td class="tborder">{{ product_detail.item.authorized_generic }}</td>
                                    <th class="tborder">バイオシミラー</th>
                                    <td class="tborder">{{ product_detail.item.biosimilar }}</td>
                                    <th class="tborder">ハイリスク薬</th>
                                    <td class="tborder">{{ product_detail.item.high_risk_drug }}</td>
                                </tr>
                                <tr>
                                    <!--<th>予備1</th>
                                    <td>{{ product_detail.item.reserve1 }}</td>
                                    <th>予備2</th>
                                    <td>{{ product_detail.item.reserve2 }}</td>-->
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">9. 貯蔵方法</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>室温</th>
                                    <td>{{ product_detail.item.room_temp }}</td>
                                    <th>冷所</th>
                                    <td>{{ product_detail.item.cold_place }}</td>
                                    <th>冷蔵</th>
                                    <td>{{ product_detail.item.cold_storage }}</td>
                                    <th>冷凍</th>
                                    <td>{{ product_detail.item.frozen }}</td>
                                    <th>暗所</th>
                                    <td>{{ product_detail.item.dark_place }}</td>
                                    <th>遮光</th>
                                    <td>{{ product_detail.item.shading }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">気密容器</th>
                                    <td class="tborder">{{ product_detail.item.airtight_container }}</td>
                                    <th class="tborder">密封容器</th>
                                    <td class="tborder">{{ product_detail.item.sealed_container }}</td>
                                    <th class="tborder">危険物</th>
                                    <td class="tborder">{{ product_detail.item.dangerous }}</td>
                                    <th class="tborder">温度上限 [℃]</th>
                                    <td class="tborder">{{ product_detail.item.temp_up }}</td>
                                    <th class="tborder">温度下限 [℃]</th>
                                    <td class="tborder">{{ product_detail.item.temp_down }}</td>
                                    <th class="tborder">その他保管上の注意</th>
                                    <td class="tborder">{{ product_detail.item.warning_other }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">10. サイズ情報</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>梱包 重量 [kg]</th>
                                    <td>{{ product_detail.item.packing_weight }}</td>
                                    <th>梱包 縦 [mm]</th>
                                    <td>{{ product_detail.item.packing_z }}</td>
                                    <th>梱包 横 [mm]</th>
                                    <td>{{ product_detail.item.packing_x }}</td>
                                    <th>梱包 高さ [mm]</th>
                                    <td>{{ product_detail.item.packing_y }}</td>
                                    <th>梱包 体積 [L]</th>
                                    <td>{{ product_detail.item.packing_volume }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">中箱 重量 [g]</th>
                                    <td class="tborder">{{ product_detail.item.middle_box_weight }}</td>
                                    <th class="tborder">中箱 縦 [mm]</th>
                                    <td class="tborder">{{ product_detail.item.middle_box_z }}</td>
                                    <th class="tborder">中箱 横 [mm]</th>
                                    <td class="tborder">{{ product_detail.item.middle_box_x }}</td>
                                    <th class="tborder">中箱 高さ [mm]</th>
                                    <td class="tborder">{{ product_detail.item.middle_box_y }}</td>
                                    <th class="tborder">中箱 体積 [mL]</th>
                                    <td class="tborder">{{ product_detail.item.middle_box_volume }}</td>
                                    <th class="tborder"></th>
                                    <td class="tborder"></td>
                                    <th class="tborder"></th>
                                    <td class="tborder"></td>
                                </tr>
                                <tr>
                                    <th class="tborder">個装 重量 [g]</th>
                                    <td class="tborder">{{ product_detail.item.individual_weight }}</td>
                                    <th class="tborder">個装 縦 [mm]</th>
                                    <td class="tborder">{{ product_detail.item.individual_z }}</td>
                                    <th class="tborder">個装 横 [mm]</th>
                                    <td class="tborder">{{ product_detail.item.individual_x }}</td>
                                    <th class="tborder">個装 高さ [mm]</th>
                                    <td class="tborder">{{ product_detail.item.individual_y }}</td>
                                    <th class="tborder">個装 体積 [mL]</th>
                                    <td class="tborder">{{ product_detail.item.individual_volume }}</td>
                                    <th class="tborder">梱包単位</th>
                                    <td class="tborder">{{ product_detail.item.packing_unit }}</td>
                                    <th class="tborder">発注単位</th>
                                    <td class="tborder">{{ product_detail.item.order_unit }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">11. 更新</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>更新区分</th>
                                    <td>{{ product_detail.item.upd_class }}</td>
                                    <th>登録年月日</th>
                                    <td>{{ product_detail.item.ins_date }}</td>
                                    <th>更新年月日</th>
                                    <td>{{ product_detail.item.upd_date }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                    <v-card tile
                            :elevation="1">
                        <v-card tile
                                color="primary lighten-4"
                                :elevation="1">
                            <v-row no-gutters>
                                <span class="ma-1">12. 追加項目</span>
                            </v-row>
                        </v-card>
                        <v-simple-table>
                            <template v-slot:default>
                                <tr>
                                    <th>GS1コード(調剤包装単位コード)</th>
                                    <td>{{ product_detail.item.gs1_code_2 }}</td>
                                    <th>GS1コード(販売包装単位コード)</th>
                                    <td>{{ product_detail.item.gs1_code_1 }}</td>
                                    <th>一般名カナ</th>
                                    <td>{{ product_detail.item.common_name_kana }}</td>
                                </tr>
                                <tr>
                                    <th class="tborder">最小薬価換算係数</th>
                                    <td class="tborder">{{ product_detail.item.min_nhi_conv_factor }}</td>
                                    <th class="tborder">旧GS1コード(旧調剤包装単位コード)</th>
                                    <td class="tborder">{{ product_detail.item.gs1_code_2_old }}</td>
                                    <th class="tborder">旧GS1コード(旧販売包装単位コード)</th>
                                    <td class="tborder">{{ product_detail.item.gs1_code_1_old }}</td>
                                    <th class="tborder">YJコード収載年月日</th>
                                    <td class="tborder">{{ product_detail.item.yj_code_list_date }}</td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>

                </v-container>
                <v-row justify="center">
                    <v-btn class="mx-2"
                           large
                           color="primary darken-3" dark
                           @click="onClose">
                        閉じる
                    </v-btn>
                </v-row>
            </template>
        </v-card>
    </v-dialog>

</template>
<script>
    export default {
        props: ["product_detail"],
        watch: {
            'product_detail.is_open'(val) {
                if (val) {
                    if (this.product_detail.item == null && this.product_detail.gs1_code !== '') {
                        this.getProduct();
                    }
                }
            }
        },
        methods: {
            async getProduct() {
                try {
                    // 商品詳細情報を取得
                    const params = new URLSearchParams();
                    const search = {
                        gs1_code: this.product_detail.gs1_code,
                        show_del_checked_flg: this.product_detail.show_del_checked_flg,
                    };
                    params.append('param', JSON.stringify(search));

                    const res = await this.axios_post('/api/Product/Search', params);
                    if (res.data.status !== "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    } else {
                        let res_item = null;
                        if (this.product_detail.getByOldCode) {
                            //旧コードでヒットしたものを表示
                            res_item = res.data.items.find(d => d.gs1_code_1_old == search.gs1_code);
                        } else {
                            //現コードでヒットしたものを表示
                            res_item = res.data.items.find(d => d.gs1_code_1 == search.gs1_code);
                        }

                        if (res_item) {
                            this.product_detail.item = res_item;
                        } else {
                            this.msg_error_dialog("商品詳細が取得できませんでした。");
                            this.onClose();
                        }
                    }
                } catch (e) {
                    this.msg_error_dialog(e);
                    this.onClose();
                }
            },
            onClose() {
                this.product_detail.is_open = false;
            },
        },
    }
</script>
<style>
    .tborder {
        border-top: solid 1px #BDBDBD;
    }
</style>